import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const Keys = {
  SET: 'set_items',
  CLEAR: 'clear_all'
}

export const state = {
  floatings: []
}
export const mutations = {
  [Keys.SET](state, items) {
    state.floatings = [].concat(items)
  },

  [Keys.CLEAR](state) {
    state.floatings = []
  }
}
export const actions = {
  refresh({ state, commit }, options) {
    options = _.extend({ force: false }, options)
    if (options.force || !state.floatings?.length)
      return post(Endpoints.getUrl('sale.product.floating.list'))
        .then(result => {
          commit(Keys.SET, result.data.items)
        })
    else
      return state.floatings
  },
  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.floatings.filter(x => x.isEnabled === true)
  },
  selectiveValue: state => {
    return state.floatings.filter(x => x.valueType === 'Selective')
  },
  allWithDisableds: state => id => {
    return state.floatings
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
